const storagePrefix = import.meta.env["VITE_REACT_APP_STORAGE_PREFIX"];
const app_domain = import.meta.env["VITE_REACT_APP_DOMAIN"];

const storage = {
  getToken: () => {
    const name = `${storagePrefix}token=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      if (c === undefined) continue;
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return JSON.parse(c.substring(name.length, c.length));
      }
    }
    return "";
  },

  setToken: (token: string) => {
    const expires = new Date();
    expires.setHours(expires.getHours() + 1); // Set token to expire in 24 hours
    document.cookie = `${storagePrefix}token=${JSON.stringify(
      token
    )}; domain=.${app_domain}; path=/; expires=${expires.toUTCString()}; Secure; SameSite=None`;
  },

  clearToken: () => {
    document.cookie = `${storagePrefix}token=; domain=.${app_domain}; path=/; max-age=0`;
  },
};

export default storage;
